import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledTdsButton = styled(TdsButton)`
  padding-top: 12px;
  padding-bottom: 12px;
`
